import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import { useT } from '../../hooks/useT';
import { getIcon } from '../../utils/iconRegistry';
import styles from './CTAButton.module.css';

function CTAButton({ labelKey, href = '', variant = 'primary', showArrow = true, icon = '' }) {
  const t = useT();
  const Icon = icon ? getIcon(icon) : null;
  const isExternal = href.startsWith('http');
  const className = `${styles.btn} ${variant === 'primary' ? styles.primary : styles.outline}`;

  const content = (
    <>
      {Icon && <Icon className={styles.icon} />}
      {t(labelKey)}
      {showArrow && <FaArrowRight className={styles.arrow} />}
    </>
  );

  if (isExternal) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className={className}>
        {content}
      </a>
    );
  }

  return (
    <Link to={href} className={className}>
      {content}
    </Link>
  );
}

export default CTAButton;
